module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/climate1.webp";